import React from 'react';
import Button from '@atlaskit/button';
import Heading from '@atlaskit/heading';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { getATLContextUrl } from '@atlassian/atl-context';
import { useIntl } from '@atlassian/jira-intl';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	fireUIAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { RequestAccessImage } from './assets/index.tsx';
import messages from './messages.tsx';

const COMPASS_SITE_ARI_PREFIX = 'ari:cloud:compass::site';

function compassSiteAriFor(cloudId: string) {
	return `${COMPASS_SITE_ARI_PREFIX}/${cloudId}`;
}

function getUserUpsellUrl(cloudId: string) {
	const compassResourceAri = compassSiteAriFor(cloudId);

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const continueUrl = window.location.href;

	return `${getATLContextUrl('id')}/join/user-access?resource=${encodeURIComponent(
		compassResourceAri,
	)}&continue=${encodeURIComponent(continueUrl)}`;
}

export const RequestAccessState = () => {
	const { formatMessage } = useIntl();
	const { cloudId } = useTenantContext();
	const upsellUrl = getUserUpsellUrl(cloudId);

	return (
		<ContextualAnalyticsData sourceType={SCREEN} sourceName="componentsTableRequestAccessState">
			<FireScreenAnalytics eventName="viewed componentsTableRequestAccessState" />
			<Inline
				xcss={contentStyles}
				alignBlock="center"
				testId="project-directories.components.compass-table.request-access-state.request-access"
			>
				<RequestAccessImage />
				<Box xcss={textStyles}>
					<Box xcss={headingStyles}>
						<Heading size="small" as="h2">
							{formatMessage(messages.heading)}
						</Heading>
					</Box>
					<Box xcss={descriptionStyles}>{formatMessage(messages.description)}</Box>
					<Button
						appearance="primary"
						target="_blank"
						href={upsellUrl}
						onClick={(_, analyticEvent) => {
							fireUIAnalytics(analyticEvent, 'compassRequestAccessUpSell');
						}}
					>
						{formatMessage(messages.requestAccessButtonText)}
					</Button>
				</Box>
			</Inline>
		</ContextualAnalyticsData>
	);
};

const contentStyles = xcss({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	width: '700px',
	marginTop: 'space.1000',
	marginBottom: 'space.250',
	marginLeft: 'auto',
	marginRight: 'auto',
});

const headingStyles = xcss({
	paddingTop: 'space.250',
});

const descriptionStyles = xcss({
	font: token('font.body'),
	paddingTop: 'space.250',
	paddingBottom: 'space.250',
});

const textStyles = xcss({
	maxWidth: '500px',
	color: 'color.text.subtle',
});
